import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DialogService as DynamicDialogService } from 'primeng/dynamicdialog';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Toast],
  template: `
    <router-outlet></router-outlet>
    <p-toast></p-toast>
  `,
  providers: [DynamicDialogService]
})
export class AppComponent {}
